import { render, staticRenderFns } from "./NewPurchase.vue?vue&type=template&id=5d8ceb02&"
import script from "./NewPurchase.vue?vue&type=script&lang=js&"
export * from "./NewPurchase.vue?vue&type=script&lang=js&"
import style0 from "./NewPurchase.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NewPurchase.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports